// extracted by mini-css-extract-plugin
export default {"menuItem":"sidebar_menuItem__wmJkT"};